import { ProjectDocRepository } from "./ProjectDocRepository";
import { defaultContractors } from "@domain/project/projectData";

/**
 * Per-project contractor directory entries. Shape is loose today —
 * Phase 2+ will formalize `Contractor` as a domain type.
 */
interface ContractorLike {
  id: number | string;
  name: string;
  role?: string;
  phone?: string;
  email?: string;
  notes?: string;
  [key: string]: unknown;
}

class ContractorRepository extends ProjectDocRepository<ContractorLike[]> {
  readonly key = "contractors";
  readonly defaultValue = defaultContractors as unknown as ContractorLike[];
}

export const contractorRepository = new ContractorRepository();
